class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.isVisible = false;
    this.formId = null;
    this.observer = null;
  }

  connectedCallback() {
    this.formId = this.dataset.formId;
    this.init();
  }

  init() {
    this.setupEventListeners();
    this.setupIntersectionObserver();
  }

  setupEventListeners() {
    const button = this.querySelector('[data-sticky-button]');

    if (button) {
      button.addEventListener('click', this.handleButtonClick.bind(this));
    }
  }

  setupIntersectionObserver() {
    const form = document.getElementById(this.formId);

    if (!form) {
      return;
    }

    const atcButton = form.querySelector('[data-add-to-cart]');

    if (!atcButton) {
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.hide();
          } else {
            const buttonRect = entry.boundingClientRect;
            const isAboveViewport = buttonRect.bottom < 20;

            if (isAboveViewport) {
              this.show();
            }
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -20px 0px' 
      }
    );

    this.observer.observe(atcButton);
  }

  show() {
    if (this.isVisible) return;
    this.isVisible = true;
    
    requestAnimationFrame(() => {
      this.toggleTargetClass(this, 'is-visible', true);
    });
  }

  hide() {
    if (!this.isVisible) return;
    
    this.toggleTargetClass(this, 'is-visible', false);
    this.isVisible = false;
    
    setTimeout(() => {
      if (!this.isVisible) {
        this.toggleTargetClass(this, 'is-visible', false);
      }
    }, 300);
  }

  handleButtonClick() {
    const form = document.getElementById(this.formId);
    if (!form) return;
    
    form.scrollIntoView({ 
      behavior: 'smooth',
      block: 'center'
    });
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  }

  toggleTargetClass(target, className, flag) {
    if (!target) return;
    target.classList.toggle(className, flag);
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
